module.exports = __webpack_public_path__ + "img/book.ba4b4503.svg";